import React from "react";
import ReactPaginate from "react-paginate";
import { useTranslation } from "react-i18next";

const Pagination = ({ page, totalPages, hasNext, hasPrev, onPageChange }) => {
  const { t } = useTranslation();

  const handlePageClick = (event) => {
    onPageChange(event.selected + 1);
  };

  return (
    <ReactPaginate
      breakLabel="..."
      nextLabel={t("pagination.next")}
      onPageChange={handlePageClick}
      pageRangeDisplayed={5}
      pageCount={totalPages}
      previousLabel={t("pagination.previous")}
      renderOnZeroPageCount={null}
      containerClassName="flex items-center justify-center space-x-2"
      pageClassName="px-3 py-1 rounded-md"
      pageLinkClassName="text-gray-700"
      activeClassName="bg-taction !text-white font-bold *:text-white"
      previousClassName={`px-3 py-1 rounded-md ${!hasPrev ? "opacity-50 cursor-not-allowed" : ""}`}
      nextClassName={`px-3 py-1 rounded-md ${!hasNext ? "opacity-50 cursor-not-allowed" : ""}`}
      disabledClassName="opacity-50 cursor-not-allowed"
    />
  );
};

export default Pagination;
